// extracted by mini-css-extract-plugin
export default {"price_list_toggle":"PriceList_price_list_toggle__pxcUz","price-list-ddl":"PriceList_price-list-ddl__X24nj","price_item":"PriceList_price_item__Yyd17"};